import React, { useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { translations } from '../i18n'
import { getLatestPosts } from '../actions/blogActions'
import BlogPreviewSection from './sections/BlogPreviewSection'

function HomeScreen() {
  const dispatch = useDispatch()
  const { lang } = useSelector(s => s.rootReducer.langRed)
  const T = translations[lang]

  useEffect(() => {
    dispatch(getLatestPosts())
  }, [dispatch])

  return (
    <div>
      {/* ── Hero ── */}
      <section id='home' className='hero'>
        <Container>
          <Row className='align-items-center gy-4'>
            <Col xs={12} md={8}>
              <h1>Francesco Alessandro Cuzzola</h1>
              <p className='hero-subtitle'>{T.hero.subtitle}</p>
              <p className='hero-tagline'>{T.hero.tagline}</p>
              <p className='hero-bio'>{T.hero.bio}</p>
              <Link to='/cv/' className='hero-btn hero-btn-primary'>{T.hero.cta_cv}</Link>
              <Link to='/blog/' className='hero-btn hero-btn-outline'>{T.hero.cta_blog}</Link>
            </Col>
            <Col xs={12} md={4} className='text-center'>
              <img src='/static/images/profile.jpg' alt='Francesco Alessandro Cuzzola' className='hero-photo' />
            </Col>
          </Row>
        </Container>
      </section>

      <BlogPreviewSection />
    </div>
  )
}

export default HomeScreen
